import {ApplicationSource, getApplicationSourceDisplay} from "../../utils/form/application_form_source";

const defaultInquirySource = "Inne";

export const getAmplitudeInquirySource = (sourceId: ApplicationSource): string => {
    return getApplicationSourceDisplay(sourceId) || defaultInquirySource;
};
import {ApplicationSource, getApplicationSourceDisplay} from "../../utils/form/application_form_source";

const defaultInquirySource = "Inne";

export const getAmplitudeInquirySource = (sourceId: ApplicationSource): string => {
    return getApplicationSourceDisplay(sourceId) || defaultInquirySource;
};
